<template>
    <div>
        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">ユーザー情報</h6>

            <form
                @submit.prevent="saveEmail"
                >
                <b-form-group
                    label-cols-sm="2"
                    label="メールアドレス"
                    label-size="sm"
                    @submit.stop.prevent
                    >
<template v-if="! modelUser.email_new">
                    <b-form-input
                        v-model="modelUser.email"
                        type="email"
                        placeholder="your@email.com"
                        >
                    </b-form-input>
                    <input-error :errors="error.email" />
                    <input-error :errors="error.onetime_password_value" />

                    <div class="text-right mt-3">
                        <button type="submit" class="btn btn-theme">変更</button>
                    </div>
</template>

<template v-if="modelUser.email_new">
                    <span>メールで届いた認証コード</span>
                    <b-form-input
                        v-model="modelUser.onetime_password"
                        type="text"
                        placeholder="123456"
                        @input="saveEmail"
                        >
                    </b-form-input>
                    <input-error :errors="error.email" />
                    <input-error :errors="error.onetime_password" />

                    <div class="text-right mt-3">
                        <b-link @click="step1">再送信</b-link>
                    </div>
</template>
                </b-form-group>
            </form>
        </b-card>

        <b-card
            class="mt-3"
            body-class="mt-3"
            >
            <h6 class="card-title">外部連携</h6>

            <b-form-group
                label-cols-sm="2"
                label="Amazon"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.inventories" />
                        <UserSettingInfo :model="modelInventories.amazon" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="2"
                label="eBay"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <input-error :errors="error.stores" />
                        <UserSettingInfo :model="modelStores.ebay" @sync="fetch" @disconnect="fetch" />
                    </b-col>
                </b-row>
            </b-form-group>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import FormDate from '@/components/FormDate.vue'
import UserSettingInfo from '@/components/UserSettingInfo.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        FormDate,
        UserSettingInfo,
    },
    props: {
//        user_uuid: {
//            type: String,
//            required: true,
//            default() {
//                return null
//            },
//        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            modelUser: {
            },
            modelInventories: {
            },
            modelStores: {
            },
            error: {
            },
        }
    },
    watch: {
        $route: {
            async handler () {
            },
            immediate: true
        }
    },
    mounted() {
        this.step1()
    },
    methods: {
        async fetch () {
            const response = await this.$store
                .dispatch('auth/me')
                .then((response) => {
                    this.modelUser = response.data.data || {}
                    this.modelInventories = response.data.data.settings.inventories || {}
                    this.modelStores = response.data.data.settings.stores || {}

                    // filter
                    this.$set(this.modelInventories, 'amazon', this.modelInventories.amazon || { provider: 'amazon', })
                    this.$set(this.modelStores, 'ebay', this.modelStores.ebay || { provider: 'ebay', })
                })
                .catch((error) => {
                })
        },
        async saveEmail () {
            if (! this.modelUser.email_new) {
                await this.$store
                    .dispatch('auth/ready', {
                        email: this.auth_email,
                        onetime_password_type: 'email',
                        onetime_password_value: this.modelUser.email,
                    })
                    .then((response) => {
                        this.$set(this.modelUser, 'email_new', this.modelUser.email)
//                        this.step1()
                    })
                    .catch((error) => {
                        this.error = error
                    })
            } else {
                if ((this.modelUser.onetime_password || '').length != 6) {
                    return
                }

                await this.$store
                    .dispatch('auth/email', {
                        onetime_password: this.modelUser.onetime_password,
                    })
                    .then((response) => {
                        this.step1()
                    })
                    .catch((error) => {
                        this.error = error
                    })
            }
        },
        async saveSettings () {
//            const response = await this.$store
//                .dispatch('auth/settings', this.modelSettings)
//                .then((response) => {
//                    this.step1()
//                })
//                .catch((error) => {
//                    this.error = error
//                })
        },
        step1 () {
            this.fetch().then(() => {
                this.$set(this.modelUser, 'email_new', null)
            })

            this.error = Object.assign({})
        },
    },
}
</script>

